import { render, staticRenderFns } from "./View24.vue?vue&type=template&id=64d1dcac&scoped=true&"
import script from "./View24.vue?vue&type=script&lang=js&"
export * from "./View24.vue?vue&type=script&lang=js&"
import style0 from "./View24.vue?vue&type=style&index=0&id=64d1dcac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d1dcac",
  null
  
)

export default component.exports